var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export var ProviderName;
(function (ProviderName) {
    ProviderName["YOUTUBE"] = "youtube";
    ProviderName["VIMEO"] = "vimeo";
    ProviderName["DAILYMOTION"] = "dailymotion";
    ProviderName["IMMOVIEWER"] = "immoviewer";
    ProviderName["MATTERPORT"] = "matterport";
    ProviderName["FIO"] = "fio";
    ProviderName["UNKNOWN"] = "unknown";
})(ProviderName || (ProviderName = {}));
// Regex patterns to identify the provider from the URL
export const PROVIDERS = {
    [ProviderName.YOUTUBE]: /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be|youtube\.fr|youtube\.de|yt\.be)/i,
    [ProviderName.VIMEO]: /^(https?:\/\/)?(www\.)?vimeo\.com/i,
    [ProviderName.DAILYMOTION]: /^(https?:\/\/)?(www\.)?dailymotion\.com/i,
    [ProviderName.IMMOVIEWER]: /^(https?:\/\/)?(app\.)?immoviewer\.com/i,
    [ProviderName.MATTERPORT]: /^(https?:\/\/)?(my\.)?matterport\.com/i,
    [ProviderName.FIO]: /^(https?:\/\/)?(www\.)?360\.fio\.de/i,
    [ProviderName.UNKNOWN]: /.*/, // generic fallback
};
const getMediaId = (url, regex) => { var _a, _b; return (_b = (_a = regex.exec(url)) === null || _a === void 0 ? void 0 : _a[1]) !== null && _b !== void 0 ? _b : null; };
// Regex patterns for each provider to extract media ID
const PROVIDER_REGEX_ID = {
    [ProviderName.YOUTUBE]: /(?:youtube\.com\/(?:watch\?.*v=|embed\/|v\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/,
    [ProviderName.VIMEO]: /vimeo\.com\/(?:.*\/)?(\d+)/,
    [ProviderName.DAILYMOTION]: /video\/([a-zA-Z0-9]+)/,
    [ProviderName.MATTERPORT]: /[?&]m=([a-zA-Z0-9]+)/,
    [ProviderName.IMMOVIEWER]: /tour\/(\d+)/,
    [ProviderName.FIO]: /tour\/([a-zA-Z0-9|_-]+)/,
    [ProviderName.UNKNOWN]: /.*/, // fallback
};
export const getProviderName = (url) => {
    for (const [provider, regex] of Object.entries(PROVIDERS)) {
        if (regex.test(url))
            return provider;
    }
    return ProviderName.UNKNOWN;
};
export const getPreviewUrl = (url, provider) => __awaiter(void 0, void 0, void 0, function* () {
    const fetcher = previewFetchers[provider];
    return fetcher ? fetcher(url) : null;
});
export const previewFetchers = {
    [ProviderName.YOUTUBE]: (url) => __awaiter(void 0, void 0, void 0, function* () {
        const mediaId = getMediaId(url, PROVIDER_REGEX_ID[ProviderName.YOUTUBE]);
        return mediaId
            ? `https://img.youtube.com/vi/${mediaId}/hqdefault.jpg`
            : null;
    }),
    [ProviderName.VIMEO]: (url) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const res = yield fetch(`https://vimeo.com/api/oembed.json?url=${encodeURIComponent(url)}`);
            if (!res.ok)
                return null;
            const data = yield res.json();
            return data.thumbnail_url || null;
        }
        catch (_a) {
            return null;
        }
    }),
    [ProviderName.DAILYMOTION]: (url) => __awaiter(void 0, void 0, void 0, function* () {
        const mediaId = getMediaId(url, PROVIDER_REGEX_ID[ProviderName.DAILYMOTION]);
        return mediaId
            ? `https://www.dailymotion.com/thumbnail/video/${mediaId}`
            : null;
    }),
    [ProviderName.MATTERPORT]: (url) => __awaiter(void 0, void 0, void 0, function* () {
        const mediaId = getMediaId(url, PROVIDER_REGEX_ID[ProviderName.MATTERPORT]);
        return mediaId
            ? `https://my.matterport.com/api/v1/player/models/${mediaId}/thumb`
            : null;
    }),
    [ProviderName.UNKNOWN]: () => __awaiter(void 0, void 0, void 0, function* () { return null; }), // fallback: use mediumImages or og:image
};
export const embedBuilders = {
    [ProviderName.YOUTUBE]: (url) => {
        const mediaId = getMediaId(url, PROVIDER_REGEX_ID[ProviderName.YOUTUBE]);
        return mediaId ? `https://www.youtube-nocookie.com/embed/${mediaId}` : null;
    },
    [ProviderName.VIMEO]: (url) => {
        const mediaId = getMediaId(url, PROVIDER_REGEX_ID[ProviderName.VIMEO]);
        return mediaId ? `https://player.vimeo.com/video/${mediaId}` : null;
    },
    [ProviderName.DAILYMOTION]: (url) => {
        const mediaId = getMediaId(url, PROVIDER_REGEX_ID[ProviderName.DAILYMOTION]);
        return mediaId ? `https://www.dailymotion.com/embed/video/${mediaId}` : null;
    },
    [ProviderName.MATTERPORT]: (url) => {
        const mediaId = getMediaId(url, PROVIDER_REGEX_ID[ProviderName.MATTERPORT]);
        return mediaId ? `https://my.matterport.com/show/?m=${mediaId}` : null;
    },
    [ProviderName.IMMOVIEWER]: (url) => url,
    [ProviderName.FIO]: (url) => url,
    [ProviderName.UNKNOWN]: () => null, // fallback: not embeddable
};
